import React from 'react';
import './Apologies.css';

function Apologies() {
  return (
    <div id='apology'>
        <p>Apologies but this website is still under construction</p>
        <p>Meanwhile if you would like to get in touch please feel free to call <a href='tel:07731860649'><strong>07731 860649</strong></a> or e-mail at <a href='mailto:contact@visionlosshub.co.uk'><strong>contact@visionlosshub.co.uk</strong></a></p>
    </div>
  )
}

export default Apologies